import DateTime from 'helpers/DateTime';

function formatDateTime(value: Date | null): string | null {
    const timestamp = value?.getTime() ?? null;
    const date = DateTime.convertNumberToDate(timestamp);
    const time = DateTime.convertNumberToTime(timestamp);

    if (date === null) {
        return null;
    }

    return time ? `${date} ${time}` : date;
}

export function formatDisplayValue(fromValue: Date | null, toValue: Date | null): string {
    return [formatDateTime(fromValue), formatDateTime(toValue)]
        .filter((value): value is string => value !== null)
        .join(' - ');
}
